module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "kp-list-group submenu-no-padding",
    attrs: {
      "id": "klickbox-step-list"
    }
  }, [_c('draggable', {
    attrs: {
      "list": _vm.list,
      "options": {
        filter: '.nondraggable'
      }
    },
    on: {
      "end": function($event) {
        return _vm.onDragEnd($event, _vm.list)
      }
    }
  }, _vm._l((_vm.list), function(step, index) {
    return _c('li', {
      staticClass: "kp-list-group-item",
      class: {
        active: _vm.stepActive.id === step.id,
        nondraggable: step.kind === 'thanks'
      },
      attrs: {
        "draggable": "",
        "id": step.id
      },
      on: {
        "click": function($event) {
          _vm.stepSetActive(step);
          _vm.canvasChangeView('steps')
        }
      }
    }, [(step.kind === 'thanks') ? _c('span', {
      staticClass: "kp-list-num"
    }, [_c('i', {
      staticClass: "kp-panel-flag"
    })]) : _vm._e(), _vm._v(" "), (step.kind === 'welcome') ? _c('span', {
      staticClass: "kp-list-num"
    }, [(step.welcome_active) ? _c('i', {
      staticClass: "kp-panel-home"
    }) : _c('i', {
      staticClass: "fa fa-times",
      staticStyle: {
        "color": "#e74c3c",
        "opacity": "0.2"
      }
    })]) : _vm._e(), _vm._v(" "), (step.kind != 'thanks' && step.kind != 'welcome') ? _c('span', {
      staticClass: "kp-list-num"
    }, [_vm._v("\n        " + _vm._s(_vm.stepDisplayPosition(step)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "kp-row",
      class: 'kp-row-' + step.kind,
      staticStyle: {
        "float": "left",
        "width": "219px"
      }
    }, [_c('span', {
      staticClass: "kp-list-label"
    }, [_c('step-icon', {
      attrs: {
        "step": step
      }
    }), _vm._v("\n          " + _vm._s(step.sanitized_title) + "\n        ")], 1), _vm._v(" "), (step.kind === 'welcome') ? _c('span', {
      staticClass: "kp-list-text"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('general.labels.first').toUpperCase()) + " " + _vm._s(_vm.$t('general.labels.step').toUpperCase()) + "\n        ")]) : _vm._e(), _vm._v(" "), (step.kind === 'thanks') ? _c('span', {
      staticClass: "kp-list-text"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('general.labels.last').toUpperCase()) + " " + _vm._s(_vm.$t('general.labels.step').toUpperCase()) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "klickbox-step-buttons",
      staticStyle: {
        "float": "left",
        "width": "219px"
      }
    }, [_c('button-jump', {
      attrs: {
        "step": step
      }
    }), _vm._v(" "), _c('button-duplicate', {
      attrs: {
        "step": step
      }
    }), _vm._v(" "), _c('button-delete', {
      attrs: {
        "step": step
      }
    })], 1)])
  }), 0)], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-4c6e8f71!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/list/Main.vue
 ** module id = 821
 ** module chunks = 1
 **/